// extracted by mini-css-extract-plugin
export default {"mainText":"TopTips_mainText__+rTrm","mainContainer":"TopTips_mainContainer__04EDl","mainContent":"TopTips_mainContent__8HGud","muted":"TopTips_muted__YucMH"};